import React from 'react'
import OverviewCard from '../../../../../../components/OverviewCard'
import { formatCurrency } from '../../../../../../utils/format'
import BadgeIcon from '../../../../../../assets/Badge.png';
import BadgeIconOrange from '../../../../../../assets/Bagde (5).png';
import BadgeIconGreen from '../../../../../../assets/Badge (1).png';
import { cohorts } from '../../../../../../api/cohort';
import { useQuery } from 'react-query';

const LearnerSummary = ({id}) => {

   const orgId = JSON.parse(sessionStorage.getItem('user') || '{}')?.org?.id;
    
    const { data: LearnersSummary, isLoading, refetch } = useQuery(
      ["learners summary"],
      () => {
        return cohorts.getCohortLearnersSummary({orgId, id});
      },
      {
        staleTime: 9000, 
        cacheTime: 9000,
        select: (data) => data,
      }
    );
  
  const summary = (summary) => isLoading ? 0 : summary

  return (
    <div className='grid grid-cols-3 gap-5 mb-4 mt-5'>
        <OverviewCard 
             title={'Total Learners'}
             iconPath={BadgeIconGreen}
             py={'py-5'}
             total={formatCurrency(summary(LearnersSummary?.numberOfParticipants), false)}
             text={
              <p className='flex justify-between text-xs'>
                 <span className='text-primary-green'>
                  completed: {summary(LearnersSummary?.completedPercentage)}% 
                 </span>
                 <span className='text-primary'>
                  inprogress:  {summary(LearnersSummary?.inProgressPercentage)}%
                  </span>
                 <span className=''>
                   not started: {summary(LearnersSummary?.notStartedPercentage)}%
                   </span>
              </p>
             }
             headerTextSize='text-2xl'
           />
          <OverviewCard 
             title={'Learners Learning Path Completion'}
             iconPath={BadgeIconOrange}
             py={'py-5'}
             total={formatCurrency(summary(LearnersSummary?.numberOfParticipants), false)}
             text={
              <p className='flex justify-between text-xs'>
                 <span className='text-primary-green'>
                  completed: {
                  summary(LearnersSummary?.numberOfParticipantsCompletedLearningPaths)}
                 </span>
                 <span className='text-primary'>
                  inprogress:  {summary(LearnersSummary?.numberOfParticipantsInProgressLearningPaths)}
                  </span>
                 <span className=''>
                   not started: {summary(LearnersSummary?.numberOfParticipantsNotStartedLearningPaths)}
                   </span>
              </p>
             }
             headerTextSize='text-2xl'
           />
           <OverviewCard 
             title={'Learners Enrollement Status'}
             iconPath={BadgeIcon}
             py={'py-5'}
             total={formatCurrency(summary(LearnersSummary?.numberOfParticipants), false)}
             text={
              <p className='flex justify-between text-xs'>
                 <span className='text-primary-green'>
                  Enrolled: {
                  summary(LearnersSummary?.numberOfParticipantsEnrolled)}
                 </span>
                 <span className='text-primary'>
                   Not Enrolled:  {summary(LearnersSummary?.numberOfParticipantsNotEnrolled)}
                  </span>
              </p>
             }
             headerTextSize='text-2xl'
           />
    </div>
  )
}

export default LearnerSummary